module.exports = __webpack_public_path__ + "img/gywmImg2.2255f236.png";